import { RootState } from "redux/rootReducer";

export const selectIsLoadingConsultationList = (state: RootState) =>
  state.consultationRequestList.loading;
export const selectConsultationListErrorMessage = (state: RootState) =>
  state.consultationRequestList.error;
export const consultationListDataResponse = (state: RootState) =>
  state.consultationRequestList.consultationListResponse;
